import Alpine from 'alpinejs';

function render(block) {
  const buttonContainer = block.querySelector('.buttonContainer ul');
  const buttons = block.querySelectorAll('button');
  // Vordefinierte Positionen für die Buttons
  const positionClasses = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];

  buttons.forEach((button, index) => {
    const li = document.createElement('li');
    // Verwende den vordefinierten Wert aus dem Array oder den letzten Wert, falls der Index größer ist
    const positionClass = positionClasses[index] || positionClasses[positionClasses.length - 1];

    li.classList.add('inline-block');
    li.classList.add('md:relative');
    li.classList.add(`${positionClass}Position`);
    li.appendChild(button);
    buttonContainer.appendChild(li);
  });
}

function refresh() {
  document.querySelectorAll('.textswitch').forEach(block => render(block));
}
Alpine.data('textSwitch', () => ({
  activeId: null,
  init() {
    // Render buttons into the side list
    refresh();

    // Initialize activeId from first item marked as opened; fallback to first button
    const preOpenBtn = this.$root.querySelector('button[data-opened="true"]');
    if (preOpenBtn) {
      this.activeId = preOpenBtn.getAttribute('aria-controls');
    } else {
      const firstBtn = this.$root.querySelector('.buttonContainer button, button');
      if (firstBtn) {
        this.activeId = firstBtn.getAttribute('aria-controls');
      }
    }

    const inNeosBackend = window.name == 'neos-content-main';

    // We are in the backend, so we need to watch for changes
    if (inNeosBackend) {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
              if (node.classList && node.classList.contains('textswitch-item')) {
                refresh();
              }
            });
          }
        }
      });

      observer.observe(document.body, { attributes: true, childList: true, subtree: true });
    }
  }

}));
